import { state } from "./State";

export const initialize = (startAtSeconds: number): void => {
  state.startAtSeconds = startAtSeconds;
};
